<script>
import apiEndpoints from "@/services/apiEndpoints";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import datetime from "@/mixins/datetime";

export default {
  mixins: [tableSearch, datetime],
  components: {
    CommonTableComponent
  },
  data() {
    return {
      isLoading: false,
      idSelected: null,
      filters: {},
      data: [],
      headers: [
        {
          text: '',
          name: 'select',
          width: 10
        },
        {
          text: '運搬先',
          name: 'destination'
        },
        {
          text: '処分方法',
          name: 'method'
        },
      ],
      waste_id: null,
      scheduleInfo: {},
    }
  },
  methods: {
    async getData() {
      if (!this.waste_id) return;

      this.isLoading = true;
      let params = {}
      params['work_order_id'] = this.scheduleInfo.schedule?.work_reservation?.work_order_id;
      if (this.isSection2) {
        params['vendor_site_id_of_transport_and_hold_2'] = this.scheduleInfo.schedule?.work_reservation?.work_order?.transport_contracts[0]?.vendor_site_id_section_2;
      }
      const url = apiEndpoints.transports_treatments(this.waste_id);
      const {status, data} = await this.$http.get(url, params);
      if (status) {
        this.data = data.result;
      }
      this.isLoading = false;
    },
    updateValue: function () {
      const selectedItem = this.data.find(x => x.id === this.idSelected) || null;
      this.$emit('dataSelected', {
        id: this.idSelected,
        selectedItem,
        scheduleInfo: this.scheduleInfo,
      })
      this.closeModal();
    },
    openModal(data) {
      this.waste_id = data.waste_id;
      this.scheduleInfo = data?.selectedScheduleInfo;
      this.idSelected = data?.selectedScheduleInfo?.wasteOrServiceBySchedule?.disposal_sites_by_waste_id;
      this.$nextTick(() => {
        this.$bvModal.show("modal-transports-treatments");
      })
    },
    closeModal() {
      this.$bvModal.hide("modal-transports-treatments");
    },
    getDestination(item) {
      if (this.isSection2) {
        return item?.disposal_site_by_waste_category?.vendor_site_of_transport_and_hold2?.name_abbreviated;
      }
      return item?.disposal_site_by_waste_category?.vendor_site_of_treatment?.name_abbreviated;
    },
    getTreatmentMethod(item) {
      return item?.disposal_site_by_waste_category?.zz_treatment_method?.treatment_method;
    },
    onClickRow(item) {
      if (item.id === this.idSelected) {
        return this.idSelected = null;
      }

      this.idSelected = item.id;
    },
  },
  computed: {
    isSection2() {
      return this.scheduleInfo.schedule.transport_and_hold_section
        && this.scheduleInfo.schedule.transport_and_hold_section.toString() === '2';
    },
  }
}
</script>
<template>
  <div class="d-xl-flex">
    <slot name="openBtn">

    </slot>
    <!-- modal area -->
    <b-modal
      title="運搬先・処分方法一覧"
      size="lg"
      id="modal-transports-treatments"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>
            <CommonTableComponent :height-class="`table-wrapper-500`">
              <thead class="table-light">
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="index"
                  :class="getHeaderClass(item)"
                >
                <span v-if="item.sortable" @click="clickSort(item.value)">
                  {{ item.text }}
                  <i :class="getSortClass(item.value)"></i>
                </span>
                  <span v-else>
                  {{ item.text }}
                </span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in data" class="cursor-pointer" @click="onClickRow(item)">
                <td class="text-center">
                  <b-form-radio
                    class="cursor-pointer"
                    v-model="idSelected"
                    :value="item.id"
                  ></b-form-radio>
                </td>
                <td>{{getDestination(item)}}</td>
                <td>{{getTreatmentMethod(item)}}</td>
              </tr>
              <tr v-if="!data.length">
                <td colspan="13" class="text-center">
                  データなし。
                </td>
              </tr>
              </tbody>
            </CommonTableComponent>
          </div>
          <div class="d-flex justify-content-end mt-3">
            <b-button
              size="lg"
              variant="primary"
              @click="updateValue"
            >
              <i class='fas fa-check'></i> {{ this.$lang.button.sure }}
            </b-button>
          </div>
        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>


<style scoped>

</style>
